import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Moon, Sun, FileText } from 'lucide-react';
import { useAtom } from 'jotai';
import { darkModeAtom } from '../lib/theme';
import { cn } from '../lib/utils';

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDark, setIsDark] = useAtom(darkModeAtom);

  return (
    <nav className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <Link to="/" className="flex items-center">
            <FileText className="w-8 h-8 text-[#60a3bc]" />
            <span className="ml-2 text-lg font-semibold text-gray-900 dark:text-white hover:text-[#60a3bc] dark:hover:text-[#60a3bc] transition-colors">
              Tell Us Your Story
            </span>
          </Link>

          {/* Desktop menu */}
          <div className="hidden md:flex md:items-center md:space-x-6">
            <a
              href="https://www.techcoffeehouse.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 dark:text-gray-400 hover:text-[#60a3bc] dark:hover:text-[#60a3bc] transition-colors"
            >
              Tech Coffee House
            </a>
            <a
              href="https://notedbytechcoffeehouse.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 dark:text-gray-400 hover:text-[#60a3bc] dark:hover:text-[#60a3bc] transition-colors"
            >
              Notes App
            </a>
            <button
              onClick={() => setIsDark(!isDark)}
              className="p-2 rounded-md text-gray-700 dark:text-gray-300 hover:text-[#60a3bc] dark:hover:text-[#60a3bc]"
              aria-label="Toggle theme"
            >
              {isDark ? (
                <Sun className="w-5 h-5" />
              ) : (
                <Moon className="w-5 h-5" />
              )}
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center space-x-2 md:hidden">
            <button
              onClick={() => setIsDark(!isDark)}
              className="p-2 rounded-md text-gray-700 dark:text-gray-300 hover:text-[#60a3bc] dark:hover:text-[#60a3bc]"
              aria-label="Toggle theme"
            >
              {isDark ? (
                <Sun className="w-5 h-5" />
              ) : (
                <Moon className="w-5 h-5" />
              )}
            </button>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 rounded-md text-gray-700 dark:text-gray-300 hover:text-[#60a3bc] dark:hover:text-[#60a3bc]"
              aria-label="Toggle menu"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div
          className={cn(
            "md:hidden",
            "transition-all duration-200 ease-in-out",
            isOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
          )}
        >
          <div className="py-2 space-y-1 border-t border-gray-200 dark:border-gray-700">
            <a
              href="https://www.techcoffeehouse.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-3 py-2 text-gray-600 dark:text-gray-400 hover:text-[#60a3bc] dark:hover:text-[#60a3bc] transition-colors"
              onClick={() => setIsOpen(false)}
            >
              Tech Coffee House
            </a>
            <a
              href="https://notedbytechcoffeehouse.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-3 py-2 text-gray-600 dark:text-gray-400 hover:text-[#60a3bc] dark:hover:text-[#60a3bc] transition-colors"
              onClick={() => setIsOpen(false)}
            >
              Notes App
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}